<script>
	import PageSection from "../../components/PageSection.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import Checkbox from "../../components/Checkbox.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";
	import { registerFormStart } from "../../tealium";

	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let lastVisitedPage = null;
	export let title = null;

	$pageNumber = pageIndex;
	$model.LastPageVisited = lastVisitedPage;
	document.title = pageTitle;

	//  Get the user Agent
	$model.UserAgent = navigator.userAgent;
	$model.referrer = document.referrer;
	$model.RegistrationSegmentId = null;

	$model.IsOptOut = true;

	//  Set the OptOut object, this isnt set from the window because it is optional, because it was creating optout entries, even when it wasnt opt out
	$model.OptOut = {
		Signature: "",
		OptOutType: "",
		DateSignature: "",
		Consent: false
	};
</script>

<PageSection>
	<div class="row justify-content-center">
		<div class="col-md-12">
			<h1 class="text-center">ONLINE OPT OUT FORM</h1>
			<h2 class="text-center">{projectSettings.classActionName}</h2>
			<h2 class="text-center">
				William Lay & Daniel Joseph Batchelor v Nuix Limited & Ors
				<span style="font-weight: 300">(S ECI 2021 04360).</span>
			</h2>
		</div>
	</div>

	<div class="row justify-content-md-center">
		<div class="col-md-12 boxed">
			<p>
				OPT OUT FOR THE CLASS ACTION CLOSED  AT 4PM AEDT ON 28 FEBRUARY 2025.
			</p>
		</div>
	</div>

</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	h2 {
		font-size: 1.1em;
		margin-bottom: 16px;
		font-weight: 700;
	}

	.boxed {
		background-color: #fff;
		border: 1px solid #ccc;
		padding: 20px;
		margin-bottom: 40px;
		text-transform: uppercase;
		text-align: center;
	}

	a {
		text-decoration: none;
	}

	.register-btn {
		margin-bottom: 20px;
	}
</style>
